var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 1C12.0795 1 13.8679 1.5425 15.389 2.5589C16.9102 3.5753 18.0958 5.01996 18.7959 6.71017C19.496 8.40039 19.6792 10.2603 19.3223 12.0546C18.9654 13.8489 18.0843 15.4971 16.7907 16.7907C15.4971 18.0844 13.8489 18.9654 12.0546 19.3223C10.2602 19.6792 8.40042 19.496 6.71021 18.7959C5.01999 18.0958 3.5753 16.9102 2.5589 15.389C1.5425 13.8679 1 12.0795 1 10.25C1 7.79675 1.97458 5.44397 3.70929 3.70926C5.444 1.97455 7.79675 1 10.25 1V1Z",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.4161,
    y1: 4.14459,
    x2: 3.41607,
    y2: 17.1446,
    stroke: "#3A4B55",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/block-icon.803edd4cff138c361de362dbe231d03b.svg";
export { ForwardRef as ReactComponent };